import React, { createContext, useState, useEffect } from 'react';
import { auth, db } from "../firebase/firebase"; // Corrected path
import { doc, onSnapshot } from "firebase/firestore";
import { updateUserData, fetchUserData } from "../utils/userData"; // Corrected path

export const TimerContext = createContext({
  showTimer: false,
  setShowTimer: () => {}, // This will be the function that also persists to Firestore
});

export const TimerProvider = ({ children }) => {
  const [showTimer, setShowTimerState] = useState(false); // Renamed state setter

  // Effect to fetch initial state from Firestore and listen for changes
  useEffect(() => {
    let unsubscribe = () => {};
    const currentUser = auth.currentUser;

    if (currentUser) {
      // Fetch initial value from localStorage for quick UI update
      const fromLS = localStorage.getItem(`showTimer_${currentUser.uid}`);
      if (fromLS !== null) {
        setShowTimerState(JSON.parse(fromLS));
      }

      // Then fetch from Firestore to ensure consistency and get the latest value
      fetchUserData(currentUser.uid).then(userData => {
        if (userData && typeof userData.showTimer === 'boolean') {
          setShowTimerState(userData.showTimer);
          // Update localStorage if Firestore had a different value
          if (JSON.parse(fromLS || "false") !== userData.showTimer) {
            localStorage.setItem(`showTimer_${currentUser.uid}`, JSON.stringify(userData.showTimer));
          }
        } else if (userData && typeof userData.showTimer === 'undefined') {
          // If the value doesn't exist in Firestore, set it based on current state (or default)
          updateUserData(currentUser.uid, { showTimer: showTimer });
        }
      });

      const userDocRef = doc(db, "users", currentUser.uid);
      unsubscribe = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (typeof data.showTimer === 'boolean') {
            setShowTimerState(data.showTimer);
            localStorage.setItem(`showTimer_${currentUser.uid}`, JSON.stringify(data.showTimer));
          }
        }
      });
    }

    return () => unsubscribe();
  }, [auth.currentUser]); // Re-run when auth.currentUser changes

  // Function to update state and persist to Firestore
  const setShowTimer = async (value) => {
    const currentUser = auth.currentUser;
    setShowTimerState(value); // Update local state immediately
    localStorage.setItem(`showTimer_${currentUser?.uid}`, JSON.stringify(value)); // Update LS

    if (currentUser) {
      try {
        await updateUserData(currentUser.uid, { showTimer: value });
      } catch (error) {
        console.error("Failed to update showTimer in Firestore:", error);
        // Optionally, revert state and LS if Firestore update fails
      }
    }
  };

  return (
    <TimerContext.Provider value={{ showTimer, setShowTimer }}>
      {children}
    </TimerContext.Provider>
  );
};
